/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { FaHandPointRight } from 'react-icons/fa';
import { IoMdVideocam } from "react-icons/io";
import { courseDuration } from '../../../utils/courseDurationCount';

const CourseContent = ({ course }) => {
    const courseSectionData = course?.courseContent;
    const totalSections = courseSectionData.length;
    const courseContent = course?.courseContent
    const totalLectures = courseContent
        .flatMap((section) => section.subSection)
        .reduce((accumulator) => accumulator + 1, 0);

    let sectionRefs = useRef({});
    const [activeSectionId, setActiveSectionId] = useState('');
    useEffect(() => {
        for (const sectionRef in sectionRefs?.current) {
            if (sectionRefs.current[sectionRef]) {
                const sectionHeight =
                    sectionRef === activeSectionId ?
                        sectionRefs.current[sectionRef].scrollHeight + 'px' : '0px';
                sectionRefs.current[sectionRef].style.height = sectionHeight;
            }
        }
    }, [activeSectionId, courseSectionData]);

    return (
        <div>
            <p className='text-3xl font-semibold mb-3'>Course Content</p>
            <div className='flex flex-wrap items-center gap-4 mb-3 text-yellow-50'>
                <span>{totalSections} Section(s)</span>
                <span>{totalLectures} Lecture(s)</span>
                <span>Total Duration {courseDuration(course?.duration)}</span>
            </div>
            <div className='w-full lg:w-[60%] bg-richblack-700 text-richblack-5 flex flex-col'>
                {courseSectionData.map((section, index) => (
                    <div key={index}>
                        <div
                            className='flex cursor-pointer justify-between items-center text-[17px] py-3 px-3 my-1'
                            onClick={() => {
                                setActiveSectionId(section?._id);
                            }}
                        >
                            <div>
                                <button type='button'>
                                    {activeSectionId !== section?._id ? (
                                        <FaHandPointRight
                                            className='transition-all duration-200'
                                        />
                                    ) : (
                                        <FaHandPointRight
                                            className='rotate-90 transition-all duration-200'
                                        />
                                    )}
                                </button>
                            </div>
                            <div
                                className='w-full overflow-hidden pl-5 bg-richblack-700 text-richblack-5'
                            >
                                {section?.sectionName}
                            </div>
                        </div>
                        <div
                            className={`transition-all overflow-hidden duration-300 bg-richblack-800`}
                            ref={(ref) => (sectionRefs.current[section?._id] = ref)}
                        >
                            {section.subSection.map((subSection, index) => (
                                <div key={index}>
                                    <div
                                        className={`flex justify-between py-2 font-medium text-richblack-5 items-center pl-7 pr-2 z-20 border-b border-richblack-700`}
                                    >
                                        <div
                                            className='flex items-center gap-x-3 py-1 w-full cursor-pointer'>
                                            <div
                                                className='flex items-center gap-4'>
                                                <IoMdVideocam className='text-lg' />
                                                <span className='sub-section-text overflow-x-hidden whitespace-nowrap hover:overflow-x-auto focus:overflow-x-auto'>{subSection.title}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CourseContent;